// extracted by mini-css-extract-plugin
module.exports =  {"checkbox":"Checkbox-module__checkbox___XqhAW","checkbox_isInline":"Checkbox-module__checkbox_isInline___cXGEw","checkbox_readOnly":"Checkbox-module__checkbox_readOnly___WuZgG"};